import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleteAction, getAction, postAction, putAction } from '@/api/manage';
import border from '@/components/border/borderType';
import fileTable from '@/components/border/fileTable';
import warn from '@/components/border/warn';
import analysis from '@/components/env-bigData/analysis';
import calendar from '@/components/env-bigData/calendar';
import calendarPie from '@/components/env-bigData/calendarPie';
import monthSelect from '@/components/date/bmonthSelect';
import dial from '@/components/env-bigData/watch';
import { queryWastDateList, queryWasteCurveAnalysis, queryScreenWarn, querWasteReport, queryStandardTreeList, queryWasteStand, standardWasteMonth } from '@/api/api';
export default {
  data: function data() {
    return {
      radioStatu: true,
      showRadio: true,
      showDial: false,
      standState: false,
      showToast: false,
      showPie: true,
      stand: [],
      showDetail: false,
      dateList: [],
      siteId: 0,
      analysisType: 11,
      start: '',
      end: '',
      waterWarnList: [],
      defaultValue: 1,
      quantum: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      colors: ['#ccc'],
      standardList: [],
      showIt: false,
      showAnalysis: false,
      standText: '',
      standLabel: '',
      defaultValues: 0,
      radioIndex: '',
      flowData: '',
      flowRaw: ''
    };
  },
  components: {
    border: border,
    fileTable: fileTable,
    analysis: analysis,
    warn: warn,
    calendar: calendar,
    monthSelect: monthSelect,
    dial: dial,
    calendarPie: calendarPie
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;
        _this.analysisType = 11;

        _this.$nextTick(function () {
          // this.getStandard(val)
          _this.defaultValues = 1;

          _this.getFlow(val);

          _this.getReport(val);

          _this.getDateList(val);

          _this.getWarn(_this.defaultValues, val, _this.selectType);

          _this.getwaterStand(val);

          _this.getPolutionData(val);
        });
      });
    }
  },
  created: function created() {// this.getStandard()
  },
  mounted: function mounted() {// setInterval(this.scroll, 1000)
  },
  methods: {
    getFlow: function getFlow(scopeId) {
      var _this2 = this;

      getAction("/online/st".concat(this.selectType, "/chart"), {
        scopeId: scopeId,
        type: 1,
        stime: this.getDay(0),
        etime: this.getDay(0),
        dataType: 12
      }).then(function (res) {
        if (res.success && res.result.records.length > 0 && res.result.records[0].factor && res.result.query.factors.length > 0) {
          var code;
          res.result.query.factors.forEach(function (item, index) {
            if (item.title == '累计流量') {
              code = item.code;
              return;
            }
          });

          if (code) {
            _this2.flowData = res.result.records[0].factor[code].hasOwnProperty('value') ? res.result.records[0].factor[code].value != null && res.result.records[0].factor[code].value != undefined ? res.result.records[0].factor[code].value : '' : '';
            _this2.flowRaw = res.result.records[0].factor[code].hasOwnProperty('raw') ? res.result.records[0].factor[code].raw != null && res.result.records[0].factor[code].raw != undefined ? res.result.records[0].factor[code].raw : '' : '';
          } else {
            _this2.flowData = '';
            _this2.flowRaw = '';
          }
        } else {
          _this2.flowData = '';
          _this2.flowRaw = '';
        }
      }); // queryWasteCurveAnalysis({
      // 	scopeId,
      // 	type: 1,
      // 	stime: this.getDay(0),
      // 	etime: this.getDay(0),
      // 	dataType: 12
      // }).then(res => {
      // 	if (res.success && res.result.records.length > 0 && res.result.records[0].factor && res.result
      // 		.query.factors.length > 0) {
      // 		let code
      // 		res.result.query.factors.forEach((item, index) => {
      // 			if (item.title == '累计流量') {
      // 				code = item.code
      // 				return;
      // 			}
      // 		})
      // 		this.flowData = res.result.records[0].factor[code].value
      // 		this.flowRaw = res.result.records[0].factor[code].raw
      // 	} else {
      // 		this.flowData = ''
      // 		this.flowRaw = ''
      // 	}
      // })
    },
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    ontoGet: function ontoGet(value, year) {
      var _this3 = this;

      console.log(value, year);
      this.resetSetItem('siteId', this.selectId);
      this.resetSetLocalItem('treeSt', '32'); // window.localStorage.setItem('treeSt','21')

      this.resetSetItem('siteType', '32');
      setTimeout(function () {
        _this3.$router.push({
          path: '/online/cn2061',
          query: {
            year: year
          }
        });
      }, 500); // if (value) this.toastText = value
      // else this.toastText = '暂无数据'
      // this.showToast = true
      // setTimeout(() => {
      // 	this.showToast = false
      // }, 2000)
    },
    ontoSelect: function ontoSelect() {
      this.showDetail = true;
      this.showIt = true;

      if (this.showDetail) {// this.$refs.pie.initBarChart('2020-11')
      }
    },
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    getwaterStand: function getwaterStand(scopeId) {
      var _this4 = this;

      getAction("/online/st".concat(this.selectType, "/standardBySite"), {
        scopeId: scopeId,
        scope: 1
      }).then(function (res) {
        if (res.success && res.result) {
          var color = [];
          var title = [];
          var a = [];
          var colors = ['green', 'red'];
          var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]]; // date.push(Object.keys(res.result['同比标准'])[0])
          // date.push(Object.keys(res.result['实时标准'])[0])
          // date.push(Object.keys(res.result['环比标准'])[0])

          if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
            if (res.result[date[0]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
            if (res.result[date[1]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
            if (res.result[date[2]].upStandard == true) {
              color.push(colors[0]);
              title.push('达标');
              a.push(1);
            } else {
              color.push(colors[1]);
              title.push('不达标');
              a.push(2);
            }
          } else {
            color.push('');
            title.push('');
            a.push(0);
          }

          _this4.showDial = true;

          _this4.$nextTick(function () {
            _this4.$refs.dials.initBarChart(title, color, date, a, 2);
          }); // let arr = []
          // let color = []
          // if(res.result['同比标准']){
          // 	color.push()
          // }
          // color.push()

        } else {
          _this4.showDial = true;

          var _date = new Date();

          var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year3 = _date.getMonth() != 0 ? _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate() : _date.getFullYear() - 1 + '-12' + '-' + _date.getDate();

          _this4.$nextTick(function () {
            _this4.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 2);
          });
        }
      });
    },
    // 获取国标数据
    getStandard: function getStandard(id) {
      var _this5 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // res.result[0].children[0].children.forEach((item, index) => {
          //   item.data.title = item.data.title.replace('类', '')
          //   item.data.show = true
          //   return item
          // })
          _this5.colors = ['#ccc'];
          var arr = [];
          var stand = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_3') {
                    arr = item1.children;
                    stand = JSON.parse(JSON.stringify(item1.children));
                    return;
                  }
                });
              }
            }
          });
          var colors = [];
          var title = [];
          arr.forEach(function (item, index) {
            // item.data.title = item.data.title.replace('类', '')
            colors.push(item.data.color);
            title.push(item.data.title); // return item
          });
          _this5.title = title;
          stand.forEach(function (item, index) {
            item.data.title = item.data.title.replace('类', '');
            return item;
          });
          _this5.colors = [].concat(colors, _toConsumableArray(_this5.colors));
          _this5.standardList = arr;
          _this5.stand = stand; // this.getReport(id)
        }
      });
    },
    monthChange: function monthChange(value) {
      this.quantum = value;

      if (this.siteId) {
        this.getReport(this.siteId);
      }
    },
    changemMonth: function changemMonth(value) {
      var _this6 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this6.showPie = true;

        if (_this6.siteId) {
          _this6.getStandmonth(_this6.siteId, value);
        }
      });
    },
    // 获取各个月份的饼图数据
    getStandmonth: function getStandmonth(id, quantum) {
      var _this7 = this;

      getAction("/st".concat(this.selectType, "/cn2061/report/standardMonth/"), {
        id: id,
        quantum: quantum
      }).then(function (res) {
        if (res.success) {
          var label = [];
          var a = [];
          var color = [];
          var arr = [];
          var data = [];
          res.result.standard.forEach(function (item, index) {
            label.push(item.title);
          });
          var monthArr = Object.keys(res.result.monthStandard);
          monthArr.forEach(function (item, index) {
            // if(res.result.monthStandard[item])
            if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
              // let arr = Object.keys(res.result.monthStandard[item])
              var arrs = [];
              var obj = {}; // for (let j = 0; j < arr.length; j++) {

              for (var i = 0; i < res.result.standard.length; i++) {
                obj.name = res.result.standard[i].title;
                obj.color = res.result.standard[i].color;

                if (res.result.monthStandard[item][res.result.standard[i].title]) {
                  obj.value = res.result.monthStandard[item][res.result.standard[i].title].num;
                  color.push(res.result.standard[i].color);
                } else {
                  obj.value = 0;
                  color.push('');
                }

                data.push(obj);
                obj = {}; // }
              }

              arr.push(data);
              data = [];
              color = [];
            } else {
              var _obj = {};

              for (var _i = 0; _i < res.result.standard.length; _i++) {
                color.push('');
                _obj.name = res.result.standard[_i].title;
                _obj.color = res.result.standard[_i].color;
                _obj.value = 0;
                data.push(_obj);
                _obj = {};
              }

              arr.push(data);
              data = [];
            }
          }); // setTimeout(() => {

          _this7.$refs.pie.initBarChart(quantum, label, arr); // }, 200)

        }
      });
    },
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    // 获取水质日历数据
    getReport: function getReport(scopeId) {
      var _this8 = this;

      getAction("/online/st".concat(this.selectType, "/report/"), {
        scopeId: scopeId,
        scope: 1,
        st: this.selectType,
        type: 3,
        quantum: this.quantum
      }).then(function (res) {
        if (res.success) {
          var a = [];

          var num = _this8.getDaysInOneMonth(_this8.quantum.split('-')[0], _this8.quantum.split('-')[1]);

          res.result.records.forEach(function (item, index) {
            if (index < num) {
              if (item.attrs.targetStandard && item.attrs.upStandard !== null) {
                if (item.attrs.upStandard) a.push(1);else a.push(2);
              } else {
                a.push(0);
              }
            }
          });

          _this8.$refs.calendar.initBarChart(_this8.quantum.split('-')[0], _this8.quantum.split('-')[1], a, ['#ccc', 'green', 'red'], ['', '达标', '不达标']);
        }
      });
    },
    scroll: function scroll() {
      var _this9 = this;

      setTimeout(function () {
        if (_this9.waterWarnList.length > 5) {
          _this9.waterWarnList.push(_this9.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this9.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
      setTimeout(function () {
        if (_this9.dateList.length > 13) {
          _this9.dateList.push(_this9.dateList[0]); // 将数组的第一个元素添加到数组的


          _this9.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    //获取预警内容
    getWarn: function getWarn(category, scopeId, st) {
      var _this10 = this;

      var params = {
        category: category,
        scope: 1,
        scopeId: scopeId,
        warnStatus: 1 // current: 1,
        // size: 20,
        // st

      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }
          });
          _this10.waterWarnList = res.result;
        } else {
          _this10.waterWarnList = [];
        }
      });
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取水质趋势
    getPolutionData: function getPolutionData(id, start) {
      var _this11 = this;

      if (id) this.siteId = id;
      if (!start) start = this.getDay(0);
      getAction("/online/st".concat(this.selectType, "/chart"), {
        scopeId: this.siteId,
        type: 1,
        stime: start,
        etime: this.getDay(0),
        dataType: this.analysisType
      }).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var obj = {};
            var popArr = [];
            var arr = [];
            var time = [];
            var labelData = [];
            var seriesData = {};
            res.result.query.factors.forEach(function (ele) {
              labelData.push(ele.title);
              res.result.records.forEach(function (element) {
                if (element.factor[ele.code]) {
                  obj.name = element.dateStr;
                  obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                  arr.push(obj);
                  obj = {};
                }
              });
              seriesData.data = arr;
              seriesData.title = ele.title;
              popArr.push(seriesData);
              seriesData = {};
              arr = [];
            });
            res.result.records.forEach(function (data) {
              time.push(data.dataTime);
            }); // this.pollutionData = popArr
            // this.time = time
            // this.labelData = labelData

            _this11.showAnalysis = false;

            _this11.$nextTick(function () {
              _this11.showAnalysis = true;
              setTimeout(function () {
                _this11.$refs.pollution.initBarChart(popArr, time, labelData);
              }, 100);
            });
          } else {
            _this11.showAnalysis = false;

            _this11.$nextTick(function () {
              _this11.showAnalysis = true;
              setTimeout(function () {
                _this11.$refs.pollution.initBarChart([], [], []);
              }, 100);
            });
          }
        }
      });
    },
    // 获取日报数据
    getDateList: function getDateList(scopeId) {
      var _this12 = this;

      queryWastDateList({
        scopeId: scopeId,
        type: 1,
        st: this.selectType,
        scope: 1
      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var state;
          var arr = [];
          var obj = {};
          res.result.query.factors.forEach(function (item, index) {
            if (res.result.records[0].factor[item.code]) {
              obj.value = res.result.records[0].factor[item.code].value != null && res.result.records[0].factor[item.code].value != undefined ? res.result.records[0].factor[item.code].value : ''; // item.standTitle = res.result.records[0].factor[item.code].standard.title
              // item.standColor = res.result.records[0].factor[item.code].standard.color
              //         if (res.result.records[0].factor[item.code].status == 1) state='达标'
              // else if(res.result.records[0].factor[item.code].status == null) state = ''
              // else state = '不达标'

              if (res.result.records[0].factor[item.code].status == 1) obj.standColor = 'green';else if (res.result.records[0].factor[item.code].status == null || res.result.records[0].factor[item.code].status == undefined) obj.standColor = '';else obj.standColor = 'red';
              obj.state = state;
              obj.title = item.title;
              obj.unitName = item.unitName;
              obj.render = _this12.renderCol(item.code, '', res.result.records[0]);
              obj.flagState = '';
              obj.flagCode = '';

              if (res.result.records[0].factor[item.code].hasOwnProperty('flag')) {
                obj.flagState = res.result.records[0].factor[item.code]['flag'].message != undefined && res.result.records[0].factor[item.code]['flag'].message != null ? res.result.records[0].factor[item.code]['flag'].message : '';
                obj.flagCode = res.result.records[0].factor[item.code]['flag'].code != undefined && res.result.records[0].factor[item.code]['flag'].code != null ? res.result.records[0].factor[item.code]['flag'].code : '';
              }

              state = '';
              arr.push(obj);
              obj = {};
              return item;
            }
          });
          _this12.standState = res.result.records[0].attrs.upStandard;
          _this12.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标'; // this.standText = res.result.records[0].currentStandard.title

          _this12.dateList = arr;
        } else {
          res.result.query.factors.forEach(function (item, index) {
            item.value = '';
            item.standColor = '';
            item.flagState = '';
            item.render = '';
            item.flagCode = '';
            return item;
          });
          _this12.standState = false;
          _this12.standLabel = '';
          _this12.dateList = res.result.query.factors;
        }
      });
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var data = record.factor[code] || {
        value: ''
      };

      if (data.status == '2') {
        return "<span  style='color:green;padding-left:15px' class='redText' title='原始数据：  " + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + "<div class='iconfont icon-xiangxiajiantou' style='float:right;color:green' ></div></span>";
      } else if (data.status == '3') {
        return "<span style='color:red;padding-left:15px' title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + "<div class='iconfont icon-iconset0414' style='float:right;color:red' ></div></span>";
      } else {
        return "<span title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data.value : '一') + '</span>';
      }
    },
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    }
  }
};